import axios from 'axios';

export default axios.create({
  baseURL: 'https://blog.api.cloudez.io/wp-json/wp/v2'
});
